import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Settings|Roles|Card|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPSettingsRolesCard';
export type SPSettingsRolesCardLocNames =
	| `${LocNameStart}ButtonCreateRole`
	| `${LocNameStart}Title`;

export const spSettingsRolesCardLocs: LocDefs<SPSettingsRolesCardLocNames> = {
	SPSettingsRolesCardButtonCreateRole: {
		defaultValue: 'Create New Role',
		description: 'Create New Role button',
		displayPath: `${pathStart}Create New Role`,
		displayType: 'Button',
		legacyName: 'Core/Settings.Roles.Button.CreateRole',
		...sharedProperties,
	},
	SPSettingsRolesCardTitle: {
		defaultValue: 'Roles',
		description: 'Roles title',
		displayPath: `${pathStart}Title`,
		displayType: 'Title',
		legacyName: 'Core/Settings.Roles.Title.PageTitle',
		...sharedProperties,
	},
};

export type SPSettingsRolesCardLocType = LocMap<SPSettingsRolesCardLocNames>;
